'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nestedtypes = require('nestedtypes');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _nestedHateoas = require('@unitedtraders/nested-hateoas');

var _nestedHateoasCommonModels = require('@unitedtraders/nested-hateoas-common-models');

var _Market = require('./enums/Market');

var _Market2 = _interopRequireDefault(_Market);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var calcFee = function calcFee(row) {
  return Object.keys(row).reduce(function (sum, key) {
    if (!key.match(/Fee$/) || !row[key]) {
      return sum;
    }

    if (!sum) {
      return row[key];
    }

    return {
      value: sum.value + row[key].value,
      currency: sum.currency
    };
  }, null);
};

var modelDescription = {
  defaults: {
    bpUsed: _nestedHateoasCommonModels.MoneyModel.value(null),
    brokerFee: _nestedHateoasCommonModels.MoneyModel.value(null),
    clearingFee: _nestedHateoasCommonModels.MoneyModel.value(null),
    date: Date.value(null),
    ecnFee: _nestedHateoasCommonModels.MoneyModel.value(null),
    exchangeFee: _nestedHateoasCommonModels.MoneyModel.value(null),
    executedQty: Number.value(null),
    market: _Market2.default.factory.value(null),
    nsccFee: _nestedHateoasCommonModels.MoneyModel.value(null),
    nsdqFee: _nestedHateoasCommonModels.MoneyModel.value(null),
    nyseFee: _nestedHateoasCommonModels.MoneyModel.value(null),
    overnightFee: _nestedHateoasCommonModels.MoneyModel.value(null),
    overnightPositionsQty: Number.value(null),
    realizedGrossPnL: _nestedHateoasCommonModels.MoneyModel.value(null),
    secFee: _nestedHateoasCommonModels.MoneyModel.value(null),
    unrealizedGrossPnL: _nestedHateoasCommonModels.MoneyModel.value(null),
    realizedNetPnL: _nestedHateoasCommonModels.MoneyModel.value(null),
    fee: _nestedHateoasCommonModels.MoneyModel.value(null),
    turnover: _nestedHateoasCommonModels.MoneyModel.value(null),
    user: _nestedHateoasCommonModels.LunaUser.value(null)
  },
  calcFees: function calcFees() {
    this.fee = calcFee(this.attributes);
    if (this.fee && this.realizedGrossPnL) {
      this.realizedNetPnL = {
        value: this.realizedGrossPnL.value - this.fee.value,
        currency: this.fee.currency
      };
    }
  }
};

// todo rename to SummaryByDateReport
function SummaryByDateReport(domainBuilder) {
  domainBuilder.defineModel('SummaryByDateReport', 'summaryByDateReports', function (model) {
    model.define({
      defaults: modelDescription.defaults,
      initialize: function initialize() {
        modelDescription.calcFees.call(this);
      }
    }).defineSearchMethod({
      name: 'findByMarkets',
      overrideUrl: 'api/me/summariesByDate',
      query: _nestedtypes.Model.extend({
        defaults: {
          range: [Date.value(null), Date.value(null)],
          market: _Market2.default.factory.value(null)
        },
        getQueryPart: function getQueryPart() {
          var searchParameters = {};
          if (this.range[0]) {
            searchParameters.from = (0, _moment2.default)(this.range[0]).format('YYYY-MM-DD');
          }
          if (this.range[1]) {
            searchParameters.to = (0, _moment2.default)(this.range[1]).format('YYYY-MM-DD');
          }
          if (this.market) {
            searchParameters.market = this.market.name;
          }
          return (0, _nestedHateoas.hash2query)(searchParameters);
        }
      }),
      additionalInfo: _nestedtypes.Model.extend({
        defaults: {
          summary: _nestedtypes.Model.extend({
            defaults: modelDescription.defaults,
            initialize: function initialize() {
              var _this = this;

              this.on('change', function () {
                modelDescription.calcFees.call(_this);
              });
            }
          })
        }
      }),
      navigation: { sort: [] }
    }).defineSearchMethod({
      name: 'findAll',
      overrideUrl: 'api/admin/summariesByDate',
      query: _nestedtypes.Model.extend({
        defaults: {
          user: String.value(null), // LunaUser
          range: [Date.value(null), Date.value(null)],
          market: _Market2.default.factory.value(null)
        },
        getQueryPart: function getQueryPart() {
          var searchParameters = {};
          if (this.user) {
            searchParameters.users = this.user;
          }
          if (this.range[0]) {
            searchParameters.from = (0, _moment2.default)(this.range[0]).format('YYYY-MM-DD');
          }
          if (this.range[1]) {
            searchParameters.to = (0, _moment2.default)(this.range[1]).format('YYYY-MM-DD');
          }
          if (this.market) {
            searchParameters.market = this.market.name;
          }
          return (0, _nestedHateoas.hash2query)(searchParameters);
        }
      }),
      additionalInfo: _nestedtypes.Model.extend({
        defaults: {
          summary: _nestedtypes.Model.extend({
            defaults: modelDescription.defaults,
            initialize: function initialize() {
              var _this2 = this;

              this.on('change', function () {
                modelDescription.calcFees.call(_this2);
              });
            }
          })
        }
      }),
      navigation: {
        sort: [{ property: 'tradingKey.date', direction: 'desc' }]
      }
    });
  });
}

exports.default = SummaryByDateReport;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/statements-domain/dist/models/SummaryByDateReport.js
// module id = 1431
// module chunks = 118